<span class="btn-label" title="Configurar">
  <i class="fa fa-wifi"></i>
</span>
